var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepsbg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 900,
    viewBox: "0 0 619 1471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_278_3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 268.24,
    ry: 153.312,
    transform: "matrix(0.95595 0.293529 -0.271877 0.962332 312.111 852.831)",
    fill: "#8349FF",
    fillOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_278_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M612.116 842.084C645.574 838.532 662.119 825.05 692.766 810.617C751.924 782.757 773.682 743.991 834.272 719.702C957.902 670.14 713.838 999.927 586.643 961.308C506.684 937.031 363.936 783.207 446.614 793.603C479.633 797.754 493.368 817.942 525.355 827.443C558.366 837.249 577.972 845.709 612.116 842.084Z",
    fill: "url(#paint0_linear_278_3)",
    fillOpacity: 0.9
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_278_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4518 780.483C6.47367 784.872 -35.2825 809.492 -75.8974 866.774C-158.176 982.816 322.544 1019.68 255.595 892.193C213.383 811.811 152.172 774.878 70.4518 780.483Z",
    fill: "#0013FF",
    fillOpacity: 0.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_278_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-44.1177 613.072C-87.302 594.345 -122.244 596.344 -166.583 620.079C-256.407 668.161 46.3828 854.523 42.2134 748.589C39.5846 681.796 11.0423 636.992 -44.1177 613.072Z",
    fill: "#00FFFF",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_278_3",
    x: -397.719,
    y: 235.566,
    width: 1419.66,
    height: 1234.53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 225,
    result: "effect1_foregroundBlur_278_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_278_3",
    x: -28.3203,
    y: 264.614,
    width: 1346.57,
    height: 1149.85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 225,
    result: "effect1_foregroundBlur_278_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_278_3",
    x: -385.404,
    y: 479.93,
    width: 947.418,
    height: 792.349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_278_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_278_3",
    x: -783.246,
    y: 0.472656,
    width: 1425.5,
    height: 1380.19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 300,
    result: "effect1_foregroundBlur_278_3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_278_3",
    x1: 735.738,
    y1: 782.796,
    x2: 532.272,
    y2: 861.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#FF005C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FFCDFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsbg);
export default __webpack_public_path__ + "static/media/stepsbg.839547e74db0c2dbd8bd32e04f9bd4b6.svg";
export { ForwardRef as ReactComponent };